// extracted by mini-css-extract-plugin
export default {"container":"DropdownIndicator_container__dNtg5"};